import { Box, Flex, Image, Text, Button,Link } from '@chakra-ui/react';
import KsSectionTitle from './KsSectionTitle';
import { ChevronRightIcon } from '@chakra-ui/icons';
import SankalpaContentArea from './SankalpaStructuredTextParser';

const ProgramDetails = ({ sectionData }) => {
    const feeCard = sectionData[2]?.simpleCards[0];

    return (
        <Box
            bgImage={{
                base: "url('https://www.datocms-assets.com/46272/1733819563-program-details-mobile-bg.png')",
                xl: "url('https://www.datocms-assets.com/46272/1733222583-program-details-sankalpabg.jpg')",
            }}
            bgSize={{ base: "100% 100%", xl: "cover" }}
            bgPosition={{ base: "center", md: "center top 30%", xl: "center" }}
            bgRepeat="no-repeat"
            position="relative"
            pt={{ base: "60px", xl: "60px" }}
            pb={{ base: "130px", xl: "100px" }}
            px={{ base: "20px", xl: "40px" }}
            maxW="1328px" // Added max-width to prevent oversized containers
            mx={{base:"0",lg:"auto"}}
        >
            <Flex
                direction={{ base: 'column', xl: 'row' }}
                gap={{ base: 2, xl: 10 }}
                align="center"
                justifyContent={{ base: 'center', xl: 'space-between' }}
                position="relative"
            >
                {/* Fee Details Card */}
                <Box
                    bg="white"
                    boxShadow="lg"
                    width={{ base: "280px", md: "420px"}}
                    // height={{base:"395px",md:"523px"}}
                    px={{base:4,md:9}}
                    pt={{base:4,md:9}}
                    pb={12}
                    textAlign="center"
                    zIndex={2}
                    ml={{ xl: "60px" }}
                    mb={{ xl: "0px" }}
                >
                    <Image
                        src={feeCard.rectangularImage.url}
                        alt={feeCard.rectangularImage.alt || 'Program Image'}
                        w={{md:"352px",xl:"380px"}}
                        objectFit="cover"
                        mb={4}
                    />
                    <Text
                        fontSize={{base:"24px",md:"26px"}}
                        fontWeight="bold"
                        color="#081B5C"
                        fontFamily="Fedra Serif Display"
                        lineHeight={{base:"25.8px",md:"27.95px"}}
                        pb="10px"
                    >
                        {feeCard?.title}
                    </Text>
                    <Text
                        fontSize={{base:"18px",md:"20px"}}
                        fontStyle="italic"
                        color="#000000"
                        fontFamily="FedraSansStd-book"
                        lineHeight={{base:"19.35px",md:"21.5px"}}
                    >
                        {feeCard?.descriptionText}
                    </Text>
                    <Link href={sectionData[3]?.linkUrl} textDecoration={"none"} _hover={{ textDecoration: 'none' }}>
                    <Button
                        mt="35px"
                        bg="#ECBD47"
                        border="none"
                        color="#031564"
                        fontWeight={{base:"600",md:"600"}}
                        width="166px"
                        height={{base:"30px",md:"50px"}}
                        borderRadius="10px"
                        fontFamily="FedraSansStd-book"
                        lineHeight={"28.8px"}
                        fontSize="18px"
                        opacity="1"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        px="18px"
                        gap="0"
                        _hover={{
                            bg: "#ECBD47",
                            color: "#031564",
                        }}
                        mx="auto"
                    >
                        {sectionData[3]?.buttonText}
                        <ChevronRightIcon boxSize="24px" />
                    </Button>
                    </Link>
                </Box>

                {/* Program Details Section */}
                <Box
                    flex="1"
                    textAlign={{ base: 'center', xl: 'start' }}
                    mt={{ base: "8px", xl: "20px" }}
                    pl={{ base: 0, xl: "20px" }}
                    pb="20px"
                    maxW={{ base: "100%", md: "700px" }}
                    pr={{xl:"30px"}}
                    position="relative"
                >
                    <Box
                        display={{ base: 'none', md: 'block' }}
                        position="absolute"
                        top={{md:"5%",xl:"-1%"}} // Adjust this as needed to place the image correctly
                        right={{md:"1%",xl:"5%"}}
                        zIndex={10} // Increase zIndex to ensure visibility
                    >
                        <Image
                            src="https://www.datocms-assets.com/46272/1733477556-sunimage-program-details.png"
                            alt="Sun Design"
                            width="100px"
                            height="100px"
                        />
                    </Box>
                    <KsSectionTitle sectionContent={sectionData[0]} />
                    <SankalpaContentArea mainContent={sectionData[1]?.body}
                        sectionContent={sectionData[1]} />
                </Box>
            </Flex>
        </Box>
    );
};

export default ProgramDetails;